import { TONS } from "../status";

export default function Badge({ rotulo, tom }) {
	return (
		<span
			className={`inline-block px-2 py-0.5 rounded-full border text-xs font-medium whitespace-nowrap ${TONS[tom]}`}
		>
			{rotulo}
		</span>
	);
}
